import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import FinancialBoard from './components/FinancialBoard';
import OccupationBoard from './components/OccupationBoard';
import {
  PERMISSION_DASHBOARD,
  PERMISSION_FINAFINA,
} from '../../shared/utils/constants';
import GraphQL from '../../GraphQL';
import { loadPermissionByUser } from '../../shared/queries/Dashboard';
import EngagementBoard from './components/EngagementBoard';

const Dashboard = () => {
  const history = useHistory();
  const [permissionDashboard, setPermissionDashboard] = useState(false);
  const [permissionFinancialBoard, setPermissionFinancialBoard] =
    useState(false);

  const loadPermission = () => {
    const query = loadPermissionByUser();
    GraphQL(query, {})
      .then((res) => {
        if (res.accessListByUser) {
          const { listOfPermission } = res.accessListByUser;
          if (
            listOfPermission.length &&
            listOfPermission.some(({ children }) =>
              children.some(({ key }) => key === PERMISSION_DASHBOARD)
            )
          ) {
            setPermissionDashboard(!permissionDashboard);
            if (
              listOfPermission.some((item) => item.key === PERMISSION_FINAFINA)
            ) {
              setPermissionFinancialBoard(!permissionFinancialBoard);
            }
          } else {
            history.push('/minime/controlpanel');
          }
        }
      })
      .catch(() => history.push('/minime/controlpanel'));
  };

  useEffect(() => {
    loadPermission();
  }, []);

  return (
    <Fragment>
      <Col md={12} className="pt-4">
        <Card>
          <CardBody>
            <div>
              {permissionDashboard && (
                <>
                  {permissionFinancialBoard && <FinancialBoard />}
                  <OccupationBoard />
                  <EngagementBoard />
                </>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default withTranslation('common')(Dashboard);
